export default __webpack_public_path__ + "static/media/Reebok.1d9dd991.png";